const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* --- Rafraichissement du panier apres ajout d'un produit complementaire --- */
/* Le bloc "Completez votre commande" ajoute bien l'article via /cart/add.js  */
/* puis emet l'evenement 'cart:refresh'. Dawn ne connait pas cet evenement :  */
/* on l'ecoute ici et on redessine le tiroir avec le contenu reel du panier.  */
document.addEventListener('cart:refresh', function () {
  var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  if (!cart || typeof cart.getSectionsToRender !== 'function') return;

  var ids = cart
    .getSectionsToRender()
    .map(function (section) {
      return section.id;
    })
    .join(',');

  fetch(window.location.pathname + '?sections=' + encodeURIComponent(ids))
    .then(function (response) {
      return response.json();
    })
    .then(function (sections) {
      cart.classList.remove('is-empty');
      cart.renderContents({ sections: sections });
      if (typeof cart.open === 'function') cart.open();
      if (typeof publish === 'function') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'addon-products' });
      }
    })
    .catch(function (error) {
      console.error('cart:refresh', error);
    });
});

/* --- Prechargement des images "lazy" apres le chargement de la page ------- */
/* Par defaut le navigateur ne telecharge une image que lorsqu'on approche    */
/* d'elle : les visuels apparaissent alors un par un pendant le defilement.   */
/* Une fois la page chargee et le navigateur au repos, on bascule les images  */
/* restantes en chargement immediat mais en priorite basse : elles arrivent   */
/* en arriere-plan sans concurrencer la banniere, et la page est complete     */
/* quand la visiteuse fait defiler. Plafonne a 40 images pour ne pas alourdir */
/* les pages collection qui contiennent des dizaines de vignettes.            */
(function () {
  var MAX_IMAGES = 40;

  function preloadLazyImages() {
    var images = document.querySelectorAll('img[loading="lazy"]');
    var limit = Math.min(images.length, MAX_IMAGES);
    for (var i = 0; i < limit; i++) {
      if ('fetchPriority' in images[i]) images[i].fetchPriority = 'low';
      images[i].loading = 'eager';
    }
  }

  function start() {
    if (navigator.connection && navigator.connection.saveData) return;
    if ('requestIdleCallback' in window) {
      requestIdleCallback(preloadLazyImages, { timeout: 2500 });
    } else {
      setTimeout(preloadLazyImages, 1200);
    }
  }

  if (document.readyState === 'complete') {
    start();
  } else {
    window.addEventListener('load', start);
  }
})();
